/* eslint-disable @typescript-eslint/camelcase */
export const sampleStatusId = 'Status';

/** 詳細の初期表示アクション **/
export const sampleInitialAction = 'UpdateItem';
export const sampleDetailInitAction = 'UpdateItem';

/** 一覧画面 一覧表示テーブルカラム */
export const ColumnList: Array<{ [k: string]: string | number }> = [
  { name: 'テンプレート名', text: 'テンプレート名', value: 'テンプレート名', order: 1, width: 50 },
  { name: '商材ID', text: '商材ID', value: '商材ID', order: 2, width: 50 },
  { name: '備考', order: 3 }
];

// 一覧内でボタンを表示するColumn
export const buttonItems = [
  {
    alwaysDisplayed: true,
    class: 'btn-normal',
    name: 'detail',
    text: '詳細',
    disabled: false
  }
];

export const MaterialTemplateSearchColumnList: Array<{ [k: string]: string | number }> = [
  { name: '詳細', text: '詳細', value: 'detail', order: 1, width: 10 },
  { name: 'テンプレート名', text: 'テンプレート名', value: 'template_name', order: 2, width: 80 },
  { name: '商材', text: '商材', value: 'commodity_id', order: 3, width: 80 },
  { name: '備考', text: '備考', value: 'template_remarks', order: 4 }
];

// 日付の表示形式変更する必要のある項目
export const MaterialTemplateSearchDateItemlist = ['birthday', 'cancellation_date'];

/** 検索パネルのGrid1区間の横幅（%） */
export const SearchPanelColumnWidth = 10;

/** 登録ガイドメッセージ */
export const authorityValidMessage = 'この内容でよろしければ「登録する」を押してください';
export const authorityInvalidMessage = '登録権限を持たないユーザです';

/** 登録・編集完了時の確認ダイアログ */
export const registerFinishText = '登録が完了いたしました';
export const registerFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'routing',
    name: 'toEdit',
    value: '詳細画面へ',
    route: '/sample/edit/:id'
  }
];
export const editFinishText = 'xxx情報を編集しました';
export const editFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'reload',
    name: 'reload',
    value: '閉じる'
  }
];
// 自動採番APIの格納フィールドIDと採番フィールドID
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace autoNumber {
  export const Define: { [k: string]: { [k: string]: string } } = {
    appNumber: {
      displayId: 'sample_application_no',
      autoFieldId: '_autonum_sample_application_no',
      linkDsFieldId: 'sample_application_no'
    },
    sampleNumber: {
      displayId: 'sample_no',
      autoFieldId: '_autonum_sample_no',
      linkDsFieldId: 'sample_no'
    }
  };
}
export const AutoNumberDefine = autoNumber.Define;

//検索時の初期表示Option
export const StatusSelectInitialOption: { text: string; value: string[] } = {
  text: '全ステータス',
  value: []
};
export const DetailNotFoundMessage = '明細情報はありませんでした';

export const filterSelect = [
  { key: 'supplier_id', target: 'supplier_staff_id' },
  { key: 'payment_destination_supplier_id', target: 'payment_information_id' },
  { key: 'item_id', target: 'standard_name', isDetail: true }
];

export const bulkMessage: { [k: string]: string } = {
  noItems: 'アイテムを選択してください',
  notMatch: 'アイテムステータスが一致していません',
  apiSuccess: '処理が完了しました',
  apiError: '以下のアイテムの処理が失敗いたしました'
};

// ActionButtonWithSearchPanelに設定(新規作成ボタン)
export const MaterialTemplateListActionButton = [
  {
    action_id: '',
    action_name: '新規登録',
    display_id: '新規登録',
    display_order: 0,
    crud_type: '',
    next_status_id: '',
    isDisable: false
  }
];

// 検索時除外するステータス
export const MaterialTemplateSearchExclusionStatus = ['mtempbase_deleted'];

// 検索時のデフォルトソート
export const MaterialTemplateDefaultSort = [
  {
    id: 'id',
    order: 'asc'
  }
];
